<template>
    <div class="login">
        
        <div class="con">
            <img src="../../assets/images/login/logo.png" alt="">
            <div class="form">
                <el-form
                :model="loginForm"
                :rules="rules"
                hide-required-asterisk
                ref="ruleForm"
                >
                    <el-form-item label="用户名" prop="userName">
                    <el-input v-model="loginForm.userName "></el-input>
                    </el-form-item>
                    <el-form-item label="密码" prop="password" >
                    <el-input v-model="loginForm.password" type="password"></el-input>
                    </el-form-item>
                    <el-form-item>
                    <el-button type="primary" @click="submitForm('ruleForm')" class="btn">登录</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
    </div>
</template>

<script>
import { login } from "../../api/news.js";

export default {
    data() {
        return {
            checked: true,
            loginForm: {
                userName: "",
                password: "",
                
            },
            rules: {
                userName: [
                    { required: true, message: "请输入用户名", trigger: "blur" }
                ],
                password: [
                    { required: true, message: "请输入密码", trigger: "blur" }
                ]
            }
        };
    },
    created() {
        let that = this;
        document.addEventListener("keydown", function(e) {
            let href = window.location.href;
            // //console.log(e);
            if (e.keyCode == 13 && href.indexOf("login") != -1) {
                //做点击回车后的事件，回车的键值是enter
                that.submitForm("ruleForm");
            }
        });
    },
    methods: {
        submitForm(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    if(!this.checked)return;
                    this.checked = !this.checked;
                    login(this.loginForm).then(res => {
                        if (res.code == 200) {
                            window.sessionStorage.setItem(
                                "user",
                                JSON.stringify(res.data)
                            );
                            this.$router.push("/news");
                            // if (res.data.isMain==1){
                            //   this.$router.push("/home/index");
                            // }else {
                            //   this.$router.push("/home/examTopic");
                            // }
                        } else {
                            this.$message({
                                type: "info",
                                message: "登陆失败"
                            });
                        }
                    });
                }
            });
        }
    }
};
</script>

<style scoped lang="less">
.login {
    width: 100%;
    height: 100vh;
    background: url(../../assets/images/login/bg.png)
        no-repeat center center;
    background-size: cover;
    // background-size: 100% 100%;
    // border: 1px solid #000;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
    .con{
        width: 100%;
        position: relative;
        img{
            width: 78.125%;
            height: auto;
            display: block;
            margin: auto;
        }
        .form{
            position: absolute;
            top: 28%;
            right: 15%;
            width: 23%;
            /deep/ .el-form-item{
                .el-input__inner{
                    border-radius: 20px;
                    background-color: #6687FF !important;
                    text-align: center;
                    color: #fff !important;
                }
                .el-form-item__label{
                    height: 20px;
                    line-height: 20px;
                    color: #0032E6;
                }
            }
            .btn{
                width: 100%;
                height:40px;
                background:rgba(84,121,255,1);
                box-shadow:0px 10px 16px 0px rgba(0,37,171,0.4);
                border-radius:25px;
                border: none;
                color: #fff;
                margin-top: 7%;
            }
            /deep/ .el-form-item.is-success .el-input__inner{
                border-color: #6687FF !important ;
            }
        }
    }
    /deep/ input:-webkit-autofill,
    /deep/ input:-webkit-autofill:hover,
    /deep/ input:-webkit-autofill:focus,
    /deep/ input:-webkit-autofill:active {
        transition-delay: 99999s;
        transition: color 99999s ease-out, background-color 99999s ease-out;
        -webkit-transition-delay: 99999s;
        -webkit-transition: color 99999s ease-out,
            background-color 99999s ease-out;
        // -webkit-text-fill-color: #fff;
        background-color: #6687FF;
    }
}

</style>
